import * as Yup from 'yup';

export const AcademicOfferingInfoSchema = Yup.object().shape({
  name: Yup.string().required('El nombre es requerido.'),
  description: Yup.string(),
  statusId: Yup.number()
    .integer('Solo se permiten números enteros.')
    .min(1, 'Debe escoger el estado.'),
});
